<!--
clubs screen
@author ab557z
-->

<template>
  <div id="contain" class="container">
    <Nav name="Club" :step="true" />
    <Spinner ref="spinner" />
    <main class="p-2">
      <ExpandedClub v-if="dispClub"
                  :key="dispClub.club_id" :title="dispClub.title" :id="dispClub.club_id"
                   :email="dispClub.email"
                   :instagram="dispClub.instagram" :facebook="dispClub.facebook" :twitter="dispClub.twitter"
                   :website="dispClub.website" :category="dispClub.club_category"
                   :description="dispClub.short_desc" :assocLink="dispClub.assoc_link"
        />
        <CovidHeader />
    </main>
    <div id="pusher"></div>
    <Footer active="clubs"/>
  </div>
</template>

<script>
// import axios from 'axios'
import ExpandedClub from '@/components/clubs/ExpandedClub.vue'
import CovidHeader from '@/components/CovidHeader.vue'
import Footer from '@/components/FooterMenu.vue'
import * as lst from '@/components/localStorage.js'
import { store } from '@/components/reactiveStore.js'

export default {
  name: 'SingleClub',
  props: ['club'],
  components: {
    ExpandedClub,
    CovidHeader,
    Footer
  },
  data () {
    return {
      dispClub: this.club
    }
  },

  mounted () {
    const clubStore = store.get()
    if (clubStore) {
      console.log(clubStore.club)
      this.dispClub = clubStore.club
    } else {
      console.error('sorry no club info from previous page')
    }
    if (this.dispClub) {
      lst.setValue('lastClub', JSON.stringify(this.dispClub))
    } else { this.dispClub = lst.getValue('lastClub') }
    window.scrollTo(0, 0)
  },
  methods: {

  }
}
</script>
<style>

</style>
